/**
 * Transition Configuration Manager
 * 
 * Handles enabling/disabling page transitions based on:
 * 1. URL parameter override (?transitions=off)
 * 2. Default-on testing mode
 */

class TransitionConfig {
  constructor() {
    this.debugMode = false;
  }

  /**
   * Determine if transitions should be enabled
   * Priority: URL off switch > default-on testing mode
   */
  shouldEnableTransitions() {
    const urlParam = this.getUrlParameter('transitions');
    if (urlParam === 'off' || urlParam === 'false') {
      this.debug('Transitions disabled via URL parameter');
      return false;
    }

    this.debug('Transitions enabled by default while testing');
    return true;
  }

  /**
   * Toggle transition preference in localStorage
   */
  toggleTransitions() {
    console.log('Transitions are enabled by default while testing. Use ?transitions=off to bypass one page load.');
  }

  /**
   * Get URL parameter value
   */
  getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  /**
   * Debug logging
   */
  debug(message) {
    if (this.debugMode) {
      console.log(`[TransitionConfig] ${message}`);
    }
  }

  /**
   * Initialize global toggle function for development
   * Usage in browser console: window.toggleTransitions()
   */
  initDevTools() {
    if (typeof window !== 'undefined') {
      window.toggleTransitions = () => this.toggleTransitions();
      window.checkTransitions = () => {
        const enabled = this.shouldEnableTransitions();
        console.log(`Transitions are currently: ${enabled ? 'ENABLED' : 'DISABLED'}`);
        console.log('Transitions are enabled by default while testing. Add ?transitions=off to bypass one page load.');
        return enabled;
      };
    }
  }
}

export default TransitionConfig;
